import {
  PermissionRouteGuard,
  type PermissionRouteGuardData,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useParams } from '@exam-management/router';
import { Outlet } from 'react-router-dom';

export default function QuestionCreationLayout() {
  const { taskId } = useParams('/task-management/question-creation/:taskId');

  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/task-management/question-creation/create',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.CREATE],
      params: {
        taskId,
      },
    },
  ];

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <Outlet />
    </PermissionRouteGuard>
  );
}
